<template>
<div class="chapter">
<div class="inner_page">
<div class="galley-rw">
<section class="body-rw Part-rw" epub:type="bodymatter part" id="Part1">
<div class="title-block-rw" id="title-block3">
<p class="title-num-rw" id="title-num1"><a href="#/Text/TOC"><strong><span class="uppercase-rw">ALL THE PRETTY LITTLE HORSES</span></strong></a></p>
</div>
<p class="firstpara-rw" id="p30">  </p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// s004-Part-001.vue?2462ed53